// import escape from 'escape-html'

import _ from 'lodash'


// function isString(value) {
//   return (typeof value === 'string' || value instanceof String)
// }

function convertResponseToError(errorResponse, errorCodes = {}) {
  if (!errorResponse) {
    return "Unknown Error"
  }
  if ((errorResponse.status >= 400 && errorResponse.status < 500) ||
    (_.has(errorResponse.data, 'result') && _.has(errorResponse.data, 'status')) ||
    (_.get(errorResponse.data, 'success') === false)) {
    let result = errorResponse.data;
    if (_.has(errorResponse.data, 'result')) {
      result = errorResponse.data.result;
    }

    if (_.has(result, 'code')) {
      let code = result["code"];
      if (code in errorCodes) {
        let errorMessage = errorCodes[code];
        if (_.isFunction(errorMessage)) {
          return errorMessage(errorResponse);
        } else {
          return errorMessage;
        }
      }
    }

    // try if one of the results matches a field
    // for (const field in result) {
    //   // if the field is an object itself
    //   if (result.hasOwnProperty(field)) {
    //     let error_code = result[field];
    //     if (_.has(errorCodes, field)) {
    //       let field_error = _.first(error_code);
    //       return errorCodes[field][field_error];
    //     }
    //     // maybe the result is an array of codes
    //     // e.g. result = ['CANNOT_FIND_ADDRESS']
    //     if (_.has(errorCodes, error_code)) {
    //       return errorCodes[error_code];
    //     }
    //   }
    // }

    // if (_.has(result, 'detail')) {
    //   return escape(result['detail'])
    // }
    // if (errorResponse.data.constructor === Array) {
    //   return errorResponse.data.map(escape).join('<br/>')
    // }
  } else if (errorResponse.status === 500) {
    return "Internal Server Error";
  }

//   if (isString(errorResponse.data)) {
//     return escape(errorResponse.data)
//   }
  return "Unknown Error";
}

export {
    convertResponseToError,
}
